// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
    position: relative;
    width: 100%;
    min-height: 100dvh;
    margin: 0;
    padding: 0;
}

.global-wrapper {
    display: flex;
    flex-wrap: wrap;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;AACnB","sourcesContent":["#root {\n    position: relative;\n    width: 100%;\n    min-height: 100dvh;\n    margin: 0;\n    padding: 0;\n}\n\n.global-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
